import React from "react";
import Moment from 'moment';
import ReactTable from 'react-table-v6'

import {
	Progress,
	Card,
  CardTitle,
	CardBody,
	Row,
	Col,
	Tooltip
} from 'reactstrap';

import Chart from 'react-c3-component';
import 'c3/c3.css';
import { Line, Bar } from 'react-chartjs-2';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';


//import img1 from '../../../assets/images/background/active-bg.png';
//import img2 from '../../../assets/images/dashboard/wavelength_color_guide.png';

class FlaggedRepairs extends React.Component {

	intervalID = 0;

	constructor(props) {
    super(props);
    this.state = {
			flaggedRepairs: [],
			noDevices: false,
			noData: false,
			tooltipOpen: false,
			deviceList: JSON.parse(localStorage.getItem('deviceList')),
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
	  };

		this.toggleTooltip = this.toggleTooltip.bind(this);
  }

	async componentDidMount() {
	 	this.getData();
		//this.intervalID = setInterval(this.getData, 5000);
	}

	toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

	componentWillUnmount() {
		//console.log("WavelengthUsage componentWillUnmount");
		clearInterval(this.intervalID);
	}

	getData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-flagged-repairs";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("get-flagged-repairs body response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				if (body.response.length>0) {


	        this.setState({ flaggedRepairs: body.response });

				} else {
					this.state.noData = true;
				}
				//this.forceUpdate();
			} else {
				this.state.noData = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	goToRepairLog(id){
		window.location.href="/repair-log/"+id;
	}

	render() {

    const data = this.state.flaggedRepairs.map((prop, key) => {

			//const buf = Buffer.from(prop.detailedissue, 'utf8');

			//buf.toString(); // 'Hello, World'

      var start = Moment(prop.ExpectedRepairDate);
      var finish = Moment();

      var days = start.diff(finish, 'days')+" days";
      console.log("days to arrive: " + days);

			return {
				id: key,
				repairId: prop.ID,
        SerialNum: prop.SerialNum,
				BatchNum: prop.BatchNum,
        DateCreated: Moment(prop.DateCreated).format('MMM Do YYYY'),
        CustomerName: { name: prop.CustomerName, juice: "Orange" },
        Flagged: prop.Flagged
			};
		});

		return (
			/*--------------------------------------------------------------------------------*/
			/* Used In Dashboard-1 [Classic]                                                  */
			/*--------------------------------------------------------------------------------*/
			<Card className="card-hover">
				<CardBody style={{ height: 250 }}>
					<Row>
						<Col xs="6" md="6" lg="6" className="text-left">
							<CardTitle>Flagged Repairs
							<i style={{color: '#ffffff'}} className="mdi mdi-information-outline ml-1" id="WavelengthUsageTooltip"/>
							<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="WavelengthUsageTooltip" toggle={this.toggleTooltip}>
								Shows most recent flagged repairs.
							</Tooltip>
							</CardTitle>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
						</Col>
					</Row>
          <ReactTable
            style={{autocomplete: 'none'}}
            columns={[
              {
								Header: "",
								accessor: "Flagged",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								minWidth: 5,
								Cell: row => (
									<div style={{ textAlign: "center", height: "20px" }}>
										{row.value==1 &&
											<i style={{color: '#f62d51', lineHeight: "0.8"}} className="mdi mdi-flag-variant mdi-18px"/>
										}
									</div>
					        )
							},
              {
                Header: "Serial",
                accessor: "SerialNum",
                style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
                minWidth: 8,
                Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
              },
              {
                Header: "Batch",
                accessor: "BatchNum",
                style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
                minWidth: 8,
                Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
              },
              {
                Header: "Creation Date",
                accessor: "DateCreated",
                style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
                minWidth: 15,
                Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
              },
              {
                Header: "Customer Name",
                accessor: "CustomerName",
                style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
                minWidth: 25,
                Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value.name}</div>
                  )
              }
            ]}
            defaultPageSize={4}
            sortable={true}
            showPaginationBottom={false}
            className="-striped -highlight"
            data={data}
            getTrGroupProps={(state, rowInfo, column, instance) => {
                    if (rowInfo !== undefined) {
                        return {
                            onClick: (e, handleOriginal) => {
                              console.log('It was in this row:', rowInfo)
                              console.log('with ID:', rowInfo.original.repairId);

                              this.goToRepairLog(rowInfo.original.repairId);
                            },
                            style: {
                                cursor: 'pointer'
                            }
                        }
                    }}
                }
          />
				</CardBody>
			</Card>

		);
	}
}

export default FlaggedRepairs;
